<template>
    <div>
        <div
         v-for="(item, index) in audio"
         :key="index"
         class="audioBox">
            <audio controlslist="nodownload noremoteplayback" controls :src="item.url.startsWith('http')? item.url : `https://${item.url}`"></audio>
        </div>
    </div>
</template>
<script>
export default {
    props: [ 'audio' ],
    created() {
        console.log(this.audio)
    },
}
</script>
<style scoped>
.audioBox {
    width: 100%;
    height: 60px;
    padding: 5px 0;
}
.audioBox audio {
    width: 100%;
    height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/resource/audioResource.vue